/* eslint-disable no-shadow */
/* eslint-disable default-param-last */
import { AnyAction } from 'redux';

const INITIAL_STORE = {
  isLoggedIn: false,
};

export enum loginActionType {
    LOGIN = 'SET_LOGIN',
    LOGOFF = 'SET_LOGOFF',
}

export default function Store(state = INITIAL_STORE, action: AnyAction) {
  switch (action.type) {
    case loginActionType.LOGIN:
      return { ...state, isLoggedIn: true };
    case loginActionType.LOGOFF:
      return { ...state, isLoggedIn: false };
    default: return state;
  }
}
